import React, { useEffect, useRef, useState } from 'react'
import './Tarifications.css'
import { Box, TextField } from '@mui/material'
import axios from 'axios'
import coinGecko from '../api/coinGecko'

const Tarifications = (props) => {

    const Logged    = localStorage.getItem('userStatus')
    const role      = localStorage.getItem('role')
  
     if (Logged === 'Logout') {
       props.history.push('/login')
     }
  
     if (Number(role) !== 1) {
       props.history.push('/')
     }

     const LineLink = true
     // const LineLink = false

    var [themeMode, setThemeMode] = useState()

    const STATUS = { STARTED: 'Traitement en cours...', }
    
      const INITIAL_COUNT1 = 300
    
      const [secondsRemaining1, setSecondsRemaining1 ] = useState(INITIAL_COUNT1)
      const [status1, setStatus1 ] = useState(STATUS.STOPPED)
    
      useEffect(()=>{
        setStatus1(STATUS.STARTED)
      },[STATUS.STARTED])
  
    useInterval(
      () => {
      if (secondsRemaining1 > 0) {
          setSecondsRemaining1(secondsRemaining1 - 1)
      } else {
          setStatus1(STATUS.STOPPED)
      }
      },
  
      status1 === STATUS.STARTED ? 1000 : null,
      // passing null stops the interval
  )
  
  function useInterval(callback, delay) {
      const savedCallback = useRef()
  
      // Remember the latest callback.
      useEffect(() => {
      savedCallback.current = callback
      }, [callback])
  
  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current()
    }
    if (delay !== null) {
      let id = setInterval(tick, delay)
      return () => clearInterval(id)
    }
  }, [delay])
  }
    
    let ThemeMode = localStorage.getItem("ThemeMode")
    
    useEffect(()=>{
      
      if(secondsRemaining1 > 0){
        setThemeMode(ThemeMode)
      }
    
    },[ThemeMode, secondsRemaining1])

    const tron        = "../images/tron.png"
    const btc         = "../images/btc.png"
    const ltc         = "../images/ltc.png"
    const usdt        = "../images/usdt.png"
    const doge        = "../images/doge.png"
    const busd        = "../images/busd.png"
    const shiba       = "../images/shiba.png"
    const polygonmatic    = "../images/polygonmatic.png"
    const ethereum        = "../images/eth.png"
    const chainlink       = "../images/chainlink.png"
    const polkadot        = "../images/pokadot.png"
    const cardano         = "../images/cardano.png"
    const solana          = "../images/solana.png"
    const payeer          = "../images/payeer.png"
    const pm              = "../images/pm.png"
    const bnb             = "../images/bnb.png"

    const [BTCModif, setBTCModif] = useState(false)
    const [TRONModif, setTRONModif] = useState(false)
    const [LTCModif, setLTCModif] = useState(false)
    const [USDTModif, setUSDTModif] = useState(false)
    const [DOGEModif, setDOGEModif] = useState(false)
    const [BUSDModif, setBUSDModif] = useState(false)
    const [SHIBAModif, setSHIBAModif] = useState(false)
    const [MATICModif, setMATICModif] = useState(false)
    const [ETHModif, setETHModif] = useState(false)
    const [LINKModif, setLINKModif] = useState(false)
    const [DOTModif, setDOTModif] = useState(false)
    const [ADAModif, setADAModif] = useState(false)
    const [SOLModif, setSOLModif] = useState(false)
    const [PMModif, setPMModif] = useState(false)
    const [BNBModif, setBNBModif] = useState(false)

    const [BTCModifRate, setBTCModifRate] = useState(false)
    const [TRONModifRate, setTRONModifRate] = useState(false)
    const [LTCModifRate, setLTCModifRate] = useState(false)
    const [USDTModifRate, setUSDTModifRate] = useState(false)
    const [DOGEModifRate, setDOGEModifRate] = useState(false)
    const [BUSDModifRate, setBUSDModifRate] = useState(false)
    const [SHIBAModifRate, setSHIBAModifRate] = useState(false)
    const [MATICModifRate, setMATICModifRate] = useState(false)
    const [ETHModifRate, setETHModifRate] = useState(false)
    const [LINKModifRate, setLINKModifRate] = useState(false)
    const [DOTModifRate, setDOTModifRate] = useState(false)
    const [ADAModifRate, setADAModifRate] = useState(false)
    const [SOLModifRate, setSOLModifRate] = useState(false)
    const [PMModifRate, setPMModifRate] = useState(false)
    const [BNBModifRate, setBNBModifRate] = useState(false)

    const [BTCModifProRate, setBTCModifProRate] = useState(false)
    const [TRONModifProRate, setTRONModifProRate] = useState(false)
    const [LTCModifProRate, setLTCModifProRate] = useState(false)
    const [USDTModifProRate, setUSDTModifProRate] = useState(false)
    const [DOGEModifProRate, setDOGEModifProRate] = useState(false)
    const [BUSDModifProRate, setBUSDModifProRate] = useState(false)
    const [SHIBAModifProRate, setSHIBAModifProRate] = useState(false)
    const [MATICModifProRate, setMATICModifProRate] = useState(false)
    const [ETHModifProRate, setETHModifProRate] = useState(false)
    const [LINKModifProRate, setLINKModifProRate] = useState(false)
    const [DOTModifProRate, setDOTModifProRate] = useState(false)
    const [ADAModifProRate, setADAModifProRate] = useState(false)
    const [SOLModifProRate, setSOLModifProRate] = useState(false)
    const [PMModifProRate, setPMModifProRate] = useState(false)
    const [BNBModifProRate, setBNBModifProRate] = useState(false)

    const [BTCModifCharge, setBTCModifCharge] = useState(false)
    const [TRONModifCharge, setTRONModifCharge] = useState(false)
    const [LTCModifCharge, setLTCModifCharge] = useState(false)
    const [USDTModifCharge, setUSDTModifCharge] = useState(false)
    const [USDTModifCharge2, setUSDTModifCharge2] = useState(false)
    const [DOGEModifCharge, setDOGEModifCharge] = useState(false)
    const [BUSDModifCharge, setBUSDModifCharge] = useState(false)
    const [SHIBAModifCharge, setSHIBAModifCharge] = useState(false)
    const [MATICModifCharge, setMATICModifCharge] = useState(false)
    const [ETHModifCharge, setETHModifCharge] = useState(false)
    const [LINKModifCharge, setLINKModifCharge] = useState(false)
    const [DOTModifCharge, setDOTModifCharge] = useState(false)
    const [ADAModifCharge, setADAModifCharge] = useState(false)
    const [SOLModifCharge, setSOLModifCharge] = useState(false)
    const [PMModifCharge, setPMModifCharge] = useState(false)
    const [BNBModifCharge, setBNBModifCharge] = useState(false)

    const [BTCModifRate2, setBTCModifRate2] = useState(false)
    const [TRONModifRate2, setTRONModifRate2] = useState(false)
    const [LTCModifRate2, setLTCModifRate2] = useState(false)
    const [USDTModifRate2, setUSDTModifRate2] = useState(false)
    const [DOGEModifRate2, setDOGEModifRate2] = useState(false)
    const [BUSDModifRate2, setBUSDModifRate2] = useState(false)
    const [SHIBAModifRate2, setSHIBAModifRate2] = useState(false)
    const [MATICModifRate2, setMATICModifRate2] = useState(false)
    const [ETHModifRate2, setETHModifRate2] = useState(false)
    const [LINKModifRate2, setLINKModifRate2] = useState(false)
    const [DOTModifRate2, setDOTModifRate2] = useState(false)
    const [ADAModifRate2, setADAModifRate2] = useState(false)
    const [SOLModifRate2, setSOLModifRate2] = useState(false)
    const [PMModifRate2, setPMModifRate2] = useState(false)
    const [BNBModifRate2, setBNBModifRate2] = useState(false)

    const [CurrencyHandle, setCurrencyHandle] = useState()

    const [BNBStop, setBNBStop] = useState(false)
    const [NT_BNB, setNT_BNB] = useState([])

    const [BTCStop, setBTCStop] = useState(false)
    const [NT_BTC, setNT_BTC] = useState([])

    const [TRONStop, setTRONStop] = useState(false)
    const [NT_TRON, setNT_TRON] = useState([])

    const [USDTStop, setUSDTStop] = useState(false)
    const [NT_USDT, setNT_USDT] = useState([])

    const [LINKStop, setLINKStop] = useState(false)
    const [NT_LINK, setNT_LINK] = useState([])

    const [MATICStop, setMATICStop] = useState(false)
    const [NT_MATIC, setNT_MATIC] = useState([])

    const [DOTEStop, setDOTEStop] = useState(false)
    const [NT_DOTE, setNT_DOTE] = useState([])

    const [BUSDStop, setBUSDStop] = useState(false)
    const [NT_BUSD, setNT_BUSD] = useState([])

    const [PMStop, setPMStop] = useState(false)
    const [NT_PM, setNT_PM] = useState([])

    const [SOLStop, setSOLStop] = useState(false)
    const [NT_SOL, setNT_SOL] = useState([])

    const [ADAStop, setADAStop] = useState(false)
    const [NT_ADA, setNT_ADA] = useState([])

    const [ETHStop, setETHStop] = useState(false)
    const [NT_ETH, setNT_ETH] = useState([])

    const [SHIBAStop, setSHIBAStop] = useState(false)
    const [NT_SHIBA, setNT_SHIBA] = useState([])

    const [DOGEStop, setDOGEStop] = useState(false)
    const [NT_DOGE, setNT_DOGE] = useState([])

    const [LTCStop, setLTCStop] = useState(false)
    const [NT_LTC, setNT_LTC] = useState([])



    const [BNBRateStop, setBNBRateStop] = useState(false)
    const [NT_rateBNB, setNT_rateBNB] = useState([])

    const [BTCRateStop, setBTCRateStop] = useState(false)
    const [NT_rateBTC, setNT_rateBTC] = useState([])

    const [TRONRateStop, setTRONRateStop] = useState(false)
    const [NT_rateTRON, setNT_rateTRON] = useState([])

    const [USDTRateStop, setUSDTRateStop] = useState(false)
    const [NT_rateUSDT, setNT_rateUSDT] = useState([])

    const [LINKRateStop, setLINKRateStop] = useState(false)
    const [NT_rateLINK, setNT_rateLINK] = useState([])

    const [MATICRateStop, setMATICRateStop] = useState(false)
    const [NT_rateMATIC, setNT_rateMATIC] = useState([])

    const [DOTERateStop, setDOTERateStop] = useState(false)
    const [NT_rateDOTE, setNT_rateDOTE] = useState([])

    const [BUSDRateStop, setBUSDRateStop] = useState(false)
    const [NT_rateBUSD, setNT_rateBUSD] = useState([])

    const [PMRateStop, setPMRateStop] = useState(false)
    const [NT_ratePM, setNT_ratePM] = useState([])

    const [SOLRateStop, setSOLRateStop] = useState(false)
    const [NT_rateSOL, setNT_rateSOL] = useState([])

    const [ADARateStop, setADARateStop] = useState(false)
    const [NT_rateADA, setNT_rateADA] = useState([])

    const [ETHRateStop, setETHRateStop] = useState(false)
    const [NT_rateETH, setNT_rateETH] = useState([])

    const [SHIBARateStop, setSHIBARateStop] = useState(false)
    const [NT_rateSHIBA, setNT_rateSHIBA] = useState([])

    const [DOGERateStop, setDOGERateStop] = useState(false)
    const [NT_rateDOGE, setNT_rateDOGE] = useState([])

    const [LTCRateStop, setLTCRateStop] = useState(false)
    const [NT_rateLTC, setNT_rateLTC] = useState([])



    const [BNBProRateStop, setBNBProRateStop] = useState(false)
    const [NT_ProrateBNB, setNT_ProrateBNB] = useState([])

    const [BTCProRateStop, setBTCProRateStop] = useState(false)
    const [NT_ProrateBTC, setNT_ProrateBTC] = useState([])

    const [TRONProRateStop, setTRONProRateStop] = useState(false)
    const [NT_ProrateTRON, setNT_ProrateTRON] = useState([])

    const [USDTProRateStop, setUSDTProRateStop] = useState(false)
    const [NT_ProrateUSDT, setNT_ProrateUSDT] = useState([])

    const [LINKProRateStop, setLINKProRateStop] = useState(false)
    const [NT_ProrateLINK, setNT_ProrateLINK] = useState([])

    const [MATICProRateStop, setMATICProRateStop] = useState(false)
    const [NT_ProrateMATIC, setNT_ProrateMATIC] = useState([])

    const [DOTEProRateStop, setDOTEProRateStop] = useState(false)
    const [NT_ProrateDOTE, setNT_ProrateDOTE] = useState([])

    const [BUSDProRateStop, setBUSDProRateStop] = useState(false)
    const [NT_ProrateBUSD, setNT_ProrateBUSD] = useState([])

    const [PMProRateStop, setPMProRateStop] = useState(false)
    const [NT_ProratePM, setNT_ProratePM] = useState([])

    const [SOLProRateStop, setSOLProRateStop] = useState(false)
    const [NT_ProrateSOL, setNT_ProrateSOL] = useState([])

    const [ADAProRateStop, setADAProRateStop] = useState(false)
    const [NT_ProrateADA, setNT_ProrateADA] = useState([])

    const [ETHProRateStop, setETHProRateStop] = useState(false)
    const [NT_ProrateETH, setNT_ProrateETH] = useState([])

    const [SHIBAProRateStop, setSHIBAProRateStop] = useState(false)
    const [NT_ProrateSHIBA, setNT_ProrateSHIBA] = useState([])

    const [DOGEProRateStop, setDOGEProRateStop] = useState(false)
    const [NT_ProrateDOGE, setNT_ProrateDOGE] = useState([])

    const [LTCProRateStop, setLTCProRateStop] = useState(false)
    const [NT_ProrateLTC, setNT_ProrateLTC] = useState([])



    const [BNBChargeStop, setBNBChargeStop] = useState(false)
    const [NT_ChargeBNB, setNT_ChargeBNB] = useState([])

    const [BTCChargeStop, setBTCChargeStop] = useState(false)
    const [NT_ChargeBTC, setNT_ChargeBTC] = useState([])

    const [TRONChargeStop, setTRONChargeStop] = useState(false)
    const [NT_ChargeTRON, setNT_ChargeTRON] = useState([])

    const [USDTChargeStop, setUSDTChargeStop] = useState(false)
    const [NT_ChargeUSDT, setNT_ChargeUSDT] = useState([])

    const [USDTCharge2Stop, setUSDTCharge2Stop] = useState(false)
    const [NT_Charge2USDT, setNT_Charge2USDT] = useState([])

    const [LINKChargeStop, setLINKChargeStop] = useState(false)
    const [NT_ChargeLINK, setNT_ChargeLINK] = useState([])

    const [MATICChargeStop, setMATICChargeStop] = useState(false)
    const [NT_ChargeMATIC, setNT_ChargeMATIC] = useState([])

    const [DOTEChargeStop, setDOTEChargeStop] = useState(false)
    const [NT_ChargeDOTE, setNT_ChargeDOTE] = useState([])

    const [BUSDChargeStop, setBUSDChargeStop] = useState(false)
    const [NT_ChargeBUSD, setNT_ChargeBUSD] = useState([])

    const [PMChargeStop, setPMChargeStop] = useState(false)
    const [NT_ChargePM, setNT_ChargePM] = useState([])

    const [SOLChargeStop, setSOLChargeStop] = useState(false)
    const [NT_ChargeSOL, setNT_ChargeSOL] = useState([])

    const [ADAChargeStop, setADAChargeStop] = useState(false)
    const [NT_ChargeADA, setNT_ChargeADA] = useState([])

    const [ETHChargeStop, setETHChargeStop] = useState(false)
    const [NT_ChargeETH, setNT_ChargeETH] = useState([])

    const [SHIBAChargeStop, setSHIBAChargeStop] = useState(false)
    const [NT_ChargeSHIBA, setNT_ChargeSHIBA] = useState([])

    const [DOGEChargeStop, setDOGEChargeStop] = useState(false)
    const [NT_ChargeDOGE, setNT_ChargeDOGE] = useState([])

    const [LTCChargeStop, setLTCChargeStop] = useState(false)
    const [NT_ChargeLTC, setNT_ChargeLTC] = useState([])



    const [BNBRate2Stop, setBNBRate2Stop] = useState(false)
    const [NT_rate2BNB, setNT_rate2BNB] = useState([])

    const [BTCRate2Stop, setBTCRate2Stop] = useState(false)
    const [NT_rate2BTC, setNT_rate2BTC] = useState([])

    const [TRONRate2Stop, setTRONRate2Stop] = useState(false)
    const [NT_rate2TRON, setNT_rate2TRON] = useState([])

    const [USDTRate2Stop, setUSDTRate2Stop] = useState(false)
    const [NT_rate2USDT, setNT_rate2USDT] = useState([])

    const [LINKRate2Stop, setLINKRate2Stop] = useState(false)
    const [NT_rate2LINK, setNT_rate2LINK] = useState([])

    const [MATICRate2Stop, setMATICRate2Stop] = useState(false)
    const [NT_rate2MATIC, setNT_rate2MATIC] = useState([])

    const [DOTERate2Stop, setDOTERate2Stop] = useState(false)
    const [NT_rate2DOTE, setNT_rate2DOTE] = useState([])

    const [BUSDRate2Stop, setBUSDRate2Stop] = useState(false)
    const [NT_rate2BUSD, setNT_rate2BUSD] = useState([])

    const [PMRate2Stop, setPMRate2Stop] = useState(false)
    const [NT_rate2PM, setNT_rate2PM] = useState([])

    const [SOLRate2Stop, setSOLRate2Stop] = useState(false)
    const [NT_rate2SOL, setNT_rate2SOL] = useState([])

    const [ADARate2Stop, setADARate2Stop] = useState(false)
    const [NT_rate2ADA, setNT_rate2ADA] = useState([])

    const [ETHRate2Stop, setETHRate2Stop] = useState(false)
    const [NT_rate2ETH, setNT_rate2ETH] = useState([])

    const [SHIBARate2Stop, setSHIBARate2Stop] = useState(false)
    const [NT_rate2SHIBA, setNT_rate2SHIBA] = useState([])

    const [DOGERate2Stop, setDOGERate2Stop] = useState(false)
    const [NT_rate2DOGE, setNT_rate2DOGE] = useState([])

    const [LTCRate2Stop, setLTCRate2Stop] = useState(false)
    const [NT_rate2LTC, setNT_rate2LTC] = useState([])

    function customBTCHandler(){ setBTCModif(!BTCModif) }
    function customTRONHandler(){ setTRONModif(!TRONModif) }
    function customLTCHandler(){ setLTCModif(!LTCModif) }
    function customUSDTHandler(){ setUSDTModif(!USDTModif) }
    function customDOGEHandler(){ setDOGEModif(!DOGEModif) }
    function customBUSDHandler(){ setBUSDModif(!BUSDModif) }
    function customSHIBAHandler(){ setSHIBAModif(!SHIBAModif) }
    function customMATICHandler(){ setMATICModif(!MATICModif) }
    function customETHHandler(){ setETHModif(!ETHModif) }
    function customLINKHandler(){ setLINKModif(!LINKModif) }
    function customDOTHandler(){ setDOTModif(!DOTModif) }
    function customADAHandler(){ setADAModif(!ADAModif) }
    function customSOLHandler(){ setSOLModif(!SOLModif) }
    function customPMHandler(){ setPMModif(!PMModif) }
    function customBNBHandler(){ setBNBModif(!BNBModif) }

    function customRateBTCHandler(){ setBTCModifRate(!BTCModifRate) }
    function customRateTRONHandler(){ setTRONModifRate(!TRONModifRate) }
    function customRateLTCHandler(){ setLTCModifRate(!LTCModifRate) }
    function customRateUSDTHandler(){ setUSDTModifRate(!USDTModifRate) }
    function customRateDOGEHandler(){ setDOGEModifRate(!DOGEModifRate) }
    function customRateBUSDHandler(){ setBUSDModifRate(!BUSDModifRate) }
    function customRateSHIBAHandler(){ setSHIBAModifRate(!SHIBAModifRate) }
    function customRateMATICHandler(){ setMATICModifRate(!MATICModifRate) }
    function customRateETHHandler(){ setETHModifRate(!ETHModifRate) }
    function customRateLINKHandler(){ setLINKModifRate(!LINKModifRate) }
    function customRateDOTHandler(){ setDOTModifRate(!DOTModifRate) }
    function customRateADAHandler(){ setADAModifRate(!ADAModifRate) }
    function customRateSOLHandler(){ setSOLModifRate(!SOLModifRate) }
    function customRatePMHandler(){ setPMModifRate(!PMModifRate) }
    function customRateBNBHandler(){ setBNBModifRate(!BNBModifRate) }

    function customProRateBTCHandler(){ setBTCModifProRate(!BTCModifProRate) }
    function customProRateTRONHandler(){ setTRONModifProRate(!TRONModifProRate) }
    function customProRateLTCHandler(){ setLTCModifProRate(!LTCModifProRate) }
    function customProRateUSDTHandler(){ setUSDTModifProRate(!USDTModifProRate) }
    function customProRateDOGEHandler(){ setDOGEModifProRate(!DOGEModifProRate) }
    function customProRateBUSDHandler(){ setBUSDModifProRate(!BUSDModifProRate) }
    function customProRateSHIBAHandler(){ setSHIBAModifProRate(!SHIBAModifProRate) }
    function customProRateMATICHandler(){ setMATICModifProRate(!MATICModifProRate) }
    function customProRateETHHandler(){ setETHModifProRate(!ETHModifProRate) }
    function customProRateLINKHandler(){ setLINKModifProRate(!LINKModifProRate) }
    function customProRateDOTHandler(){ setDOTModifProRate(!DOTModifProRate) }
    function customProRateADAHandler(){ setADAModifProRate(!ADAModifProRate) }
    function customProRateSOLHandler(){ setSOLModifProRate(!SOLModifProRate) }
    function customProRatePMHandler(){ setPMModifProRate(!PMModifProRate) }
    function customProRateBNBHandler(){ setBNBModifProRate(!BNBModifProRate) }

    function customChargeBTCHandler(){ setBTCModifCharge(!BTCModifCharge) }
    function customChargeTRONHandler(){ setTRONModifCharge(!TRONModifCharge) }
    function customChargeLTCHandler(){ setLTCModifCharge(!LTCModifCharge) }
    function customChargeUSDTHandler(){ setUSDTModifCharge(!USDTModifCharge) }
    function customCharge2USDTHandler(){ setUSDTModifCharge2(!USDTModifCharge2) }
    function customChargeDOGEHandler(){ setDOGEModifCharge(!DOGEModifCharge) }
    function customChargeBUSDHandler(){ setBUSDModifCharge(!BUSDModifCharge) }
    function customChargeSHIBAHandler(){ setSHIBAModifCharge(!SHIBAModifCharge) }
    function customChargeMATICHandler(){ setMATICModifCharge(!MATICModifCharge) }
    function customChargeETHHandler(){ setETHModifCharge(!ETHModifCharge) }
    function customChargeLINKHandler(){ setLINKModifCharge(!LINKModifCharge) }
    function customChargeDOTHandler(){ setDOTModifCharge(!DOTModifCharge) }
    function customChargeADAHandler(){ setADAModifCharge(!ADAModifCharge) }
    function customChargeSOLHandler(){ setSOLModifCharge(!SOLModifCharge) }
    function customChargePMHandler(){ setPMModifCharge(!PMModifCharge) }
    function customChargeBNBHandler(){ setBNBModifCharge(!BNBModifCharge) }

    function customRate2BTCHandler(){ setBTCModifRate2(!BTCModifRate2) }
    function customRate2TRONHandler(){ setTRONModifRate2(!TRONModifRate2) }
    function customRate2LTCHandler(){ setLTCModifRate2(!LTCModifRate2) }
    function customRate2USDTHandler(){ setUSDTModifRate2(!USDTModifRate2) }
    function customRate2DOGEHandler(){ setDOGEModifRate2(!DOGEModifRate2) }
    function customRate2BUSDHandler(){ setBUSDModifRate2(!BUSDModifRate2) }
    function customRate2SHIBAHandler(){ setSHIBAModifRate2(!SHIBAModifRate2) }
    function customRate2MATICHandler(){ setMATICModifRate2(!MATICModifRate2) }
    function customRate2ETHHandler(){ setETHModifRate2(!ETHModifRate2) }
    function customRate2LINKHandler(){ setLINKModifRate2(!LINKModifRate2) }
    function customRate2DOTHandler(){ setDOTModifRate2(!DOTModifRate2) }
    function customRate2ADAHandler(){ setADAModifRate2(!ADAModifRate2) }
    function customRate2SOLHandler(){ setSOLModifRate2(!SOLModifRate2) }
    function customRate2PMHandler(){ setPMModifRate2(!PMModifRate2) }
    function customRate2BNBHandler(){ setBNBModifRate2(!BNBModifRate2) }

    const [coins2, setCoins2] = useState([])
    
    useEffect(()=>{
      
      const fetchDada2 = async () => {
    
        const response = await coinGecko.get('/coins/markets', {
          params: {
            vs_currency: 'usd',
            ids:
              'binancecoin,binance-usd,tron,litecoin,dogecoin,shiba-inu,matic-network,chainlink,polkadot,cardano,solana',
          },
        })
        if(response.data.length > 0){
          setCoins2(response.data)
        }
      }
      fetchDada2()
    },[])
    
      // useEffect(()=>{
      //     const fetchBTC = async () => {
      //       try {
      //           const response = await coinGeckoData.get('/coins/')
      //           const _data = response.data.coins
      //           const BTCFilted = _data.filter((items) => { return items.id === 'bitcoin' })
                
      //           if(BTCFilted[0].price){
      //             // setBTCprice(Number(BTCFilted[0].price))
      //             localStorage.setItem('BTCprice', BTCFilted[0].price)
    
      //             try {
          
      //                 axios.post('/api/update-nt-btc', 
      //                     {
      //                         ID: 1,
      //                         btc: BTCFilted[0].price,
      //                         createdAt: new Date(),
      //                         updatedAt: new Date(),
      //                     }
      //                     )
          
      //             } catch (err) {}
      //           }
      //       } catch (error) { }
      //     }
      //     fetchBTC()
    
      // },[])
    
    useEffect(()=>{
      const fetchBTC = async () => {
  
        try {
          if(coins2.length > 0){
  
            if(coins2[0].current_price){
  
              try {
      
                  axios.post('/api/update-nt-bnb', 
                      {
                          ID: 1,
                          bnb: coins2[0].current_price,
                          createdAt: new Date(),
                          updatedAt: new Date(),
                      }
                      )
      
              } catch (err) {}
            }
          }
        } catch (error) {
        }
      }
      fetchBTC()
  
    },[coins2])
    
    useEffect(()=>{
        const fetchBTC = async () => {
    
        try {
            if(coins2.length > 0){
    
            if(coins2[1].current_price){
    
                try {
        
                    axios.post('/api/update-nt-sol', 
                        {
                            ID: 1,
                            sol: coins2[1].current_price,
                            createdAt: new Date(),
                            updatedAt: new Date(),
                        }
                        )
        
                } catch (err) {}
            }
            }
        } catch (error) {
        }
        }
        fetchBTC()
    
    },[coins2])
  
    useEffect(()=>{
    const fetchBTC = async () => {

      try {
        if(coins2.length > 0){

          if(coins2[2].current_price){

            try {
    
                axios.post('/api/update-nt-ada', 
                    {
                        ID: 1,
                        ada: coins2[2].current_price,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    )
    
            } catch (err) {}
          }
        }
      } catch (error) {
      }
    }
    fetchBTC()

    },[coins2])
    
    useEffect(()=>{
        const fetchBTC = async () => {
    
          try {
            if(coins2.length > 0){
    
              if(coins2[3].current_price){
    
                try {
        
                    axios.post('/api/update-nt-doge', 
                        {
                            ID: 1,
                            doge: coins2[3].current_price,
                            createdAt: new Date(),
                            updatedAt: new Date(),
                        }
                        )
        
                } catch (err) {}
              }
            }
          } catch (error) {
          }
        }
        fetchBTC()
    
    },[coins2])
    
    useEffect(()=>{
      const fetchBTC = async () => {
  
        try {
          if(coins2.length > 0){
  
            if(coins2[4].current_price){
  
              try {
      
                  axios.post('/api/update-nt-shiba', 
                      {
                          ID: 1,
                          shiba: coins2[4].current_price,
                          createdAt: new Date(),
                          updatedAt: new Date(),
                      }
                      )
      
              } catch (err) {}
            }
          }
        } catch (error) {
        }
      }
      fetchBTC()
  
    },[coins2])
    
    // useEffect(()=>{
      //     const fetchBTC = async () => {
    
      //       try {
      //           const response = await coinGeckoData.get('/coins/')
      //           const _data = response.data.coins
      //           const USDTFilted = _data.filter((items) => {
      //             return items.id === 'tether'
      //           })
      //           if(USDTFilted[0].price){
      //             // setUSDTprice(Number(USDTFilted[0].price))
      //             localStorage.setItem('USDTprice', USDTFilted[0].price)
    
      //             try {
          
      //                 axios.post('/api/update-nt-usdt', 
      //                     {
      //                         ID: 1,
      //                         usdt: USDTFilted[0].price,
      //                         createdAt: new Date(),
      //                         updatedAt: new Date(),
      //                     }
      //                     )
          
      //             } catch (err) {}
    
      //           }
      //       } catch (error) {
      //       }
      //     }
      //     fetchBTC()
    
    // },[])
    
    useEffect(()=>{
        const fetchBTC = async () => {
  
          try {
            if(coins2.length > 0){
  
              if(coins2[7].current_price){
  
                try {
        
                    axios.post('/api/update-nt-tron', 
                        {
                            ID: 1,
                            tron: coins2[7].current_price,
                            createdAt: new Date(),
                            updatedAt: new Date(),
                        }
                        )
        
                } catch (err) {}
              }
            }
          } catch (error) {
          }
        }
        fetchBTC()
  
    },[coins2])
    
    useEffect(()=>{
      const fetchBTC = async () => {
  
        try {
          if(coins2.length > 0){
  
            if(coins2[8].current_price){
  
              try {
      
                  axios.post('/api/update-nt-matic', 
                      {
                          ID: 1,
                          matic: coins2[8].current_price,
                          createdAt: new Date(),
                          updatedAt: new Date(),
                      }
                      )
      
              } catch (err) {}
            }
          }
        } catch (error) {
        }
      }
      fetchBTC()
  
    },[coins2])
  
    useEffect(()=>{
      const fetchBTC = async () => {
  
        try {
          if(coins2.length > 0){
  
            if(coins2[9].current_price){
  
              try {
      
                  axios.post('/api/update-nt-ltc', 
                      {
                          ID: 1,
                          ltc: coins2[9].current_price,
                          createdAt: new Date(),
                          updatedAt: new Date(),
                      }
                      )
      
              } catch (err) {}
            }
          }
        } catch (error) {
        }
      }
      fetchBTC()
  
    },[coins2])
    
    useEffect(()=>{
        const fetchBTC = async () => {
    
          try {
            if(coins2.length > 0){
    
              if(coins2[10].current_price){
    
                try {
        
                    axios.post('/api/update-nt-busd', 
                        {
                            ID: 1,
                            busd: coins2[10].current_price,
                            createdAt: new Date(),
                            updatedAt: new Date(),
                        }
                        )
        
                } catch (err) {}
              }
            }
          } catch (error) {
          }
        }
        fetchBTC()
    
    },[coins2])
    
    // useEffect(()=>{
      //     const fetchBTC = async () => {
    
      //       try {
      //           const response = await coinGeckoData.get('/coins/')
      //           const _data = response.data.coins
      //           const ETHFilted = _data.filter((items) => {
      //             return items.id === 'ethereum'
      //           })
      //           if(ETHFilted[0].price){
      //             // setETHEREUMprice(Number(ETHFilted[0].price))
      //             localStorage.setItem('ETHEREUMprice', ETHFilted[0].price)
    
      //             try {
          
      //                 axios.post('/api/update-nt-eth', 
      //                     {
      //                         ID: 1,
      //                         eth: ETHFilted[0].price,
      //                         createdAt: new Date(),
      //                         updatedAt: new Date(),
      //                     }
      //                     )
          
      //             } catch (err) {}
    
      //           }
      //       } catch (error) {
      //       }
      //     }
      //     fetchBTC()
    
    // },[])

    const currencyHandleChange = ({target: {value}}) => {
      setCurrencyHandle(value)
    }

    const validateBTCHandler = () => {

        setBTCModif(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-btc', 
                    {
                        ID: 1,
                        btc: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateBTCRateHandler = () => {

        setBTCModifRate(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-ratebtc', 
                    {
                        ID: 1,
                        btc: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateBTCProRateHandler = () => {

        setBTCModifProRate(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-proratebtc', 
                    {
                        ID: 1,
                        btc: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateBTCChargeHandler = () => {

        setBTCModifCharge(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-chargebtc', 
                    {
                        ID: 1,
                        btc: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateBTCRate2Handler = () => {

        setBTCModifRate2(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-rate2btc', 
                    {
                        ID: 1,
                        btc: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }

    const validateTRONHandler = () => {

        setTRONModif(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-tron', 
                    {
                        ID: 1,
                        tron: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }
    }
    const validateRateTRONHandler = () => {

        setTRONModifRate(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-ratetron', 
                    {
                        ID: 1,
                        tron: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }
    }
    const validateProRateTRONHandler = () => {

        setTRONModifProRate(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-proratetron', 
                    {
                        ID: 1,
                        tron: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }
    }
    const validateChargeTRONHandler = () => {

        setTRONModifCharge(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-chargetron', 
                    {
                        ID: 1,
                        tron: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }
    }
    const validateRate2TRONHandler = () => {

        setTRONModifRate2(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-rate2tron', 
                    {
                        ID: 1,
                        tron: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }
    }

    const validateLTCHandler = () => {

        setLTCModif(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-ltc', 
                    {
                        ID: 1,
                        ltc: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }
    }
    const validateRateLTCHandler = () => {

        setLTCModifRate(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-rateltc', 
                    {
                        ID: 1,
                        ltc: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }
    }
    const validateProRateLTCHandler = () => {

        setLTCModifProRate(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-prorateltc', 
                    {
                        ID: 1,
                        ltc: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }
    }
    const validateChargeLTCHandler = () => {

        setLTCModifCharge(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-chargeltc', 
                    {
                        ID: 1,
                        ltc: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }
    }
    const validateRate2LTCHandler = () => {

        setLTCModifRate2(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-rate2ltc', 
                    {
                        ID: 1,
                        ltc: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }
    }

    const validateUSDTHandler = () => {

        setUSDTModif(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-usdt', 
                    {
                        ID: 1,
                        usdt: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateRateUSDTHandler = () => {

        setUSDTModifRate(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-rateusdt', 
                    {
                        ID: 1,
                        usdt: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateProRateUSDTHandler = () => {

        setUSDTModifProRate(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-prorateusdt', 
                    {
                        ID: 1,
                        usdt: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateChargeUSDTHandler = () => {

        setUSDTModifCharge(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-chargeusdt', 
                    {
                        ID: 1,
                        usdt: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateCharge2USDTHandler = () => {

        setUSDTModifCharge2(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-chargeusdt2', 
                    {
                        ID: 1,
                        usdt: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateRate2USDTHandler = () => {

        setUSDTModifRate2(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-rate2usdt', 
                    {
                        ID: 1,
                        usdt: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }

    const validateDOGEHandler = () => {

        setDOGEModif(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-doge', 
                    {
                        ID: 1,
                        doge: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateRateDOGEHandler = () => {

        setDOGEModifRate(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-ratedoge', 
                    {
                        ID: 1,
                        doge: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateProRateDOGEHandler = () => {

        setDOGEModifProRate(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-proratedoge', 
                    {
                        ID: 1,
                        doge: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateChargeDOGEHandler = () => {

        setDOGEModifCharge(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-chargedoge', 
                    {
                        ID: 1,
                        doge: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateRate2DOGEHandler = () => {

        setDOGEModifRate2(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-rate2doge', 
                    {
                        ID: 1,
                        doge: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }

    const validateBUSDHandler = () => {

        setBUSDModif(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-busd', 
                    {
                        ID: 1,
                        busd: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateRateBUSDHandler = () => {

        setBUSDModifRate(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-ratebusd', 
                    {
                        ID: 1,
                        busd: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateProRateBUSDHandler = () => {

        setBUSDModifProRate(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-proratebusd', 
                    {
                        ID: 1,
                        busd: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateChargeBUSDHandler = () => {

        setBUSDModifCharge(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-chargebusd', 
                    {
                        ID: 1,
                        busd: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateRate2BUSDHandler = () => {

        setBUSDModifRate2(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-rate2busd', 
                    {
                        ID: 1,
                        busd: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }

    const validateSHIBAHandler = () => {

        setSHIBAModif(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-shiba', 
                    {
                        ID: 1,
                        shiba: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateRateSHIBAHandler = () => {

        setSHIBAModifRate(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-rateshiba', 
                    {
                        ID: 1,
                        shiba: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateProRateSHIBAHandler = () => {

        setSHIBAModifProRate(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-prorateshiba', 
                    {
                        ID: 1,
                        shiba: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateChargeSHIBAHandler = () => {

        setSHIBAModifCharge(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-chargeshiba', 
                    {
                        ID: 1,
                        shiba: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateRate2SHIBAHandler = () => {

        setSHIBAModifRate2(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-rate2shiba', 
                    {
                        ID: 1,
                        shiba: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }

    const validateMATICHandler = () => {

        setMATICModif(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-matic', 
                    {
                        ID: 1,
                        matic: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateRateMATICHandler = () => {

        setMATICModifRate(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-ratematic', 
                    {
                        ID: 1,
                        matic: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateProRateMATICHandler = () => {

        setMATICModifProRate(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-proratematic', 
                    {
                        ID: 1,
                        matic: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateChargeMATICHandler = () => {

        setMATICModifCharge(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-chargematic', 
                    {
                        ID: 1,
                        matic: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateRate2MATICHandler = () => {

        setMATICModifRate2(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-rate2matic', 
                    {
                        ID: 1,
                        matic: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }

    const validateETHHandler = () => {

        setETHModif(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-eth', 
                    {
                        ID: 1,
                        eth: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateRateETHHandler = () => {

        setETHModifRate(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-rateeth', 
                    {
                        ID: 1,
                        eth: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateProRateETHHandler = () => {

        setETHModifProRate(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-prorateeth', 
                    {
                        ID: 1,
                        eth: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateChargeETHHandler = () => {

        setETHModifCharge(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-chargeeth', 
                    {
                        ID: 1,
                        eth: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateRate2ETHHandler = () => {

        setETHModifRate2(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-rate2eth', 
                    {
                        ID: 1,
                        eth: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }

    const validateLINKHandler = () => {

        setLINKModif(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-link', 
                    {
                        ID: 1,
                        link: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateRateLINKHandler = () => {

        setLINKModifRate(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-ratelink', 
                    {
                        ID: 1,
                        link: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateProRateLINKHandler = () => {

        setLINKModifProRate(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-proratelink', 
                    {
                        ID: 1,
                        link: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateChargeLINKHandler = () => {

        setLINKModifCharge(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-chargelink', 
                    {
                        ID: 1,
                        link: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateRate2LINKHandler = () => {

        setLINKModifRate2(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-rate2link', 
                    {
                        ID: 1,
                        link: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }

    const validateDOTHandler = () => {

        setDOTModif(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-dote', 
                    {
                        ID: 1,
                        dote: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateRateDOTHandler = () => {

        setDOTModifRate(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-ratedote', 
                    {
                        ID: 1,
                        dote: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateProRateDOTHandler = () => {

        setDOTModifProRate(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-proratedote', 
                    {
                        ID: 1,
                        dote: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateChargeDOTHandler = () => {

        setDOTModifCharge(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-chargedote', 
                    {
                        ID: 1,
                        dote: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateRate2DOTHandler = () => {

        setDOTModifRate2(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-rate2dote', 
                    {
                        ID: 1,
                        dote: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }

    const validateADAHandler = () => {

        setADAModif(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-ada', 
                    {
                        ID: 1,
                        ada: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateRateADAHandler = () => {

        setADAModifRate(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-rateada', 
                    {
                        ID: 1,
                        ada: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateProRateADAHandler = () => {

        setADAModifProRate(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-prorateada', 
                    {
                        ID: 1,
                        ada: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateChargeADAHandler = () => {

        setADAModifCharge(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-chargeada', 
                    {
                        ID: 1,
                        ada: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateRate2ADAHandler = () => {

        setADAModifRate2(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-rate2ada', 
                    {
                        ID: 1,
                        ada: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }

    const validateSOLHandler = () => {

        setSOLModif(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-sol', 
                    {
                        ID: 1,
                        sol: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateRateSOLHandler = () => {

        setSOLModifRate(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-ratesol', 
                    {
                        ID: 1,
                        sol: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateProRateSOLHandler = () => {

        setSOLModifProRate(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-proratesol', 
                    {
                        ID: 1,
                        sol: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateChargeSOLHandler = () => {

        setSOLModifCharge(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-chargesol', 
                    {
                        ID: 1,
                        sol: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateRate2SOLHandler = () => {

        setSOLModifRate2(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-rate2sol', 
                    {
                        ID: 1,
                        sol: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }

    const validatePMHandler = () => {

        setPMModif(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-pm', 
                    {
                        ID: 1,
                        pm: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateRatePMHandler = () => {

        setPMModifRate(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-ratepm', 
                    {
                        ID: 1,
                        pm: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateProRatePMHandler = () => {

        setPMModifProRate(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-proratepm', 
                    {
                        ID: 1,
                        pm: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateChargePMHandler = () => {

        setPMModifCharge(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-chargepm', 
                    {
                        ID: 1,
                        pm: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateRate2PMHandler = () => {

        setPMModifRate2(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-rate2pm', 
                    {
                        ID: 1,
                        pm: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }

    const validateBNBHandler = () => {

        setBNBModif(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-bnb', 
                    {
                        ID: 1,
                        bnb: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateRateBNBHandler = () => {

        setBNBModifRate(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-ratebnb', 
                    {
                        ID: 1,
                        bnb: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateProRateBNBHandler = () => {

        setBNBModifProRate(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-proratebnb', 
                    {
                        ID: 1,
                        bnb: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateChargeBNBHandler = () => {

        setBNBModifCharge(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-chargebnb', 
                    {
                        ID: 1,
                        bnb: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }
    const validateRate2BNBHandler = () => {

        setBNBModifRate2(false)

        if(CurrencyHandle !== ""){

            try {
    
                axios.post('/api/update-nt-rate2bnb', 
                    {
                        ID: 1,
                        bnb: CurrencyHandle,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}
        }

    }

    const validateCreateChargeBNBHandler = () => {

            try {
                axios.post('/api/create-nt-chargeusdt2', 
                    {
                        ID: 1,
                        usdt: 1.21,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                    ).then((res)=>{
                        if(res.data.msg === "success"){
    
                            if(LineLink){
                            window.location.replace("https://nkab-exchange.net/tarification");
                            } else {
                            window.location.replace("http://localhost:3000/tarification");
                            }
                        }
                    })
    
            } catch (err) {}

    }
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!BTCStop){

                try {
                    const res = await axios.get('/api/nt-btc')

                    if(res.data[0].ID){
                        setNT_BTC(res.data[0].btc)
                        setBTCStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[BTCStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!BTCRateStop){

                try {
                    const res = await axios.get('/api/nt-ratebtc')

                    if(res.data[0].ID){
                        setNT_rateBTC(res.data[0].btc)
                        setBTCRateStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[BTCRateStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!BTCProRateStop){

                try {
                    const res = await axios.get('/api/nt-proratebtc')

                    if(res.data[0].ID){
                        setNT_ProrateBTC(res.data[0].btc)
                        setBTCProRateStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[BTCProRateStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!BTCChargeStop){

                try {
                    const res = await axios.get('/api/nt-chargebtc')

                    if(res.data[0].ID){
                        setNT_ChargeBTC(res.data[0].btc)
                        setBTCChargeStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[BTCChargeStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!BTCRate2Stop){

                try {
                    const res = await axios.get('/api/nt-rate2btc')

                    if(res.data[0].ID){
                        setNT_rate2BTC(res.data[0].btc)
                        setBTCRate2Stop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[BTCRate2Stop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!TRONStop){

                try {
                    const res = await axios.get('/api/nt-tron')

                    if(res.data[0].ID){
                        setNT_TRON(res.data[0].tron)
                        setTRONStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[TRONStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!TRONProRateStop){

                try {
                    const res = await axios.get('/api/nt-proratetron')

                    if(res.data[0].ID){
                        setNT_ProrateTRON(res.data[0].tron)
                        setTRONProRateStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[TRONProRateStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!TRONChargeStop){

                try {
                    const res = await axios.get('/api/nt-chargetron')

                    if(res.data[0].ID){
                        setNT_ChargeTRON(res.data[0].tron)
                        setTRONChargeStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[TRONChargeStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!TRONRateStop){

                try {
                    const res = await axios.get('/api/nt-ratetron')

                    if(res.data[0].ID){
                        setNT_rateTRON(res.data[0].tron)
                        setTRONRateStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[TRONRateStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!TRONRate2Stop){

                try {
                    const res = await axios.get('/api/nt-rate2tron')

                    if(res.data[0].ID){
                        setNT_rate2TRON(res.data[0].tron)
                        setTRONRate2Stop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[TRONRate2Stop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!LTCStop){

                try {
                    const res = await axios.get('/api/nt-ltc')

                    if(res.data[0].ID){
                        setNT_LTC(res.data[0].ltc)
                        setLTCStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[LTCStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!LTCRateStop){

                try {
                    const res = await axios.get('/api/nt-rateltc')

                    if(res.data[0].ID){
                        setNT_rateLTC(res.data[0].ltc)
                        setLTCRateStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[LTCRateStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!LTCProRateStop){

                try {
                    const res = await axios.get('/api/nt-prorateltc')

                    if(res.data[0].ID){
                        setNT_ProrateLTC(res.data[0].ltc)
                        setLTCProRateStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[LTCProRateStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!LTCChargeStop){

                try {
                    const res = await axios.get('/api/nt-chargeltc')

                    if(res.data[0].ID){
                        setNT_ChargeLTC(res.data[0].ltc)
                        setLTCChargeStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[LTCChargeStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!LTCRate2Stop){

                try {
                    const res = await axios.get('/api/nt-rate2ltc')

                    if(res.data[0].ID){
                        setNT_rate2LTC(res.data[0].ltc)
                        setLTCRate2Stop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[LTCRate2Stop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!USDTStop){

                try {
                    const res = await axios.get('/api/nt-usdt')

                    if(res.data[0].ID){
                        setNT_USDT(res.data[0].usdt)
                        setUSDTStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[USDTStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!USDTRateStop){

                try {
                    const res = await axios.get('/api/nt-rateusdt')

                    if(res.data[0].ID){
                        setNT_rateUSDT(res.data[0].usdt)
                        setUSDTRateStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[USDTRateStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!USDTProRateStop){

                try {
                    const res = await axios.get('/api/nt-prorateusdt')

                    if(res.data[0].ID){
                        setNT_ProrateUSDT(res.data[0].usdt)
                        setUSDTProRateStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[USDTProRateStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!USDTChargeStop){

                try {
                    const res = await axios.get('/api/nt-chargeusdt')

                    if(res.data[0].ID){
                        setNT_ChargeUSDT(res.data[0].usdt)
                        setUSDTChargeStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[USDTChargeStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!USDTCharge2Stop){

                try {
                    const res = await axios.get('/api/nt-chargeusdt2')

                    if(res.data[0].ID){
                        setNT_Charge2USDT(res.data[0].usdt)
                        setUSDTCharge2Stop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[USDTCharge2Stop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!USDTRate2Stop){

                try {
                    const res = await axios.get('/api/nt-rate2usdt')

                    if(res.data[0].ID){
                        setNT_rate2USDT(res.data[0].usdt)
                        setUSDTRate2Stop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[USDTRate2Stop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!DOGEStop){

                try {
                    const res = await axios.get('/api/nt-doge')

                    if(res.data[0].ID){
                        setNT_DOGE(res.data[0].doge)
                        setDOGEStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[DOGEStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!DOGERateStop){

                try {
                    const res = await axios.get('/api/nt-ratedoge')

                    if(res.data[0].ID){
                        setNT_rateDOGE(res.data[0].doge)
                        setDOGERateStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[DOGERateStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!DOGEProRateStop){

                try {
                    const res = await axios.get('/api/nt-proratedoge')

                    if(res.data[0].ID){
                        setNT_ProrateDOGE(res.data[0].doge)
                        setDOGEProRateStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[DOGEProRateStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!DOGEChargeStop){

                try {
                    const res = await axios.get('/api/nt-chargedoge')

                    if(res.data[0].ID){
                        setNT_ChargeDOGE(res.data[0].doge)
                        setDOGEChargeStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[DOGEChargeStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!DOGERate2Stop){

                try {
                    const res = await axios.get('/api/nt-rate2doge')

                    if(res.data[0].ID){
                        setNT_rate2DOGE(res.data[0].doge)
                        setDOGERate2Stop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[DOGERate2Stop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!BUSDStop){

                try {
                    const res = await axios.get('/api/nt-busd')

                    if(res.data[0].ID){
                        setNT_BUSD(res.data[0].busd)
                        setBUSDStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[BUSDStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!BUSDRateStop){

                try {
                    const res = await axios.get('/api/nt-ratebusd')

                    if(res.data[0].ID){
                        setNT_rateBUSD(res.data[0].busd)
                        setBUSDRateStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[BUSDRateStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!BUSDProRateStop){

                try {
                    const res = await axios.get('/api/nt-proratebusd')

                    if(res.data[0].ID){
                        setNT_ProrateBUSD(res.data[0].busd)
                        setBUSDProRateStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[BUSDProRateStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!BUSDChargeStop){

                try {
                    const res = await axios.get('/api/nt-chargebusd')

                    if(res.data[0].ID){
                        setNT_ChargeBUSD(res.data[0].busd)
                        setBUSDChargeStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[BUSDChargeStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!BUSDRate2Stop){

                try {
                    const res = await axios.get('/api/nt-rate2busd')

                    if(res.data[0].ID){
                        setNT_rate2BUSD(res.data[0].busd)
                        setBUSDRate2Stop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[BUSDRate2Stop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!SHIBAStop){

                try {
                    const res = await axios.get('/api/nt-shiba')

                    if(res.data[0].ID){
                        setNT_SHIBA(res.data[0].shiba)
                        setSHIBAStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[SHIBAStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!SHIBARateStop){

                try {
                    const res = await axios.get('/api/nt-rateshiba')

                    if(res.data[0].ID){
                        setNT_rateSHIBA(res.data[0].shiba)
                        setSHIBARateStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[SHIBARateStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!SHIBAProRateStop){

                try {
                    const res = await axios.get('/api/nt-prorateshiba')

                    if(res.data[0].ID){
                        setNT_ProrateSHIBA(res.data[0].shiba)
                        setSHIBAProRateStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[SHIBAProRateStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!SHIBAChargeStop){

                try {
                    const res = await axios.get('/api/nt-chargeshiba')

                    if(res.data[0].ID){
                        setNT_ChargeSHIBA(res.data[0].shiba)
                        setSHIBAChargeStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[SHIBAChargeStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!SHIBARate2Stop){

                try {
                    const res = await axios.get('/api/nt-rate2shiba')

                    if(res.data[0].ID){
                        setNT_rate2SHIBA(res.data[0].shiba)
                        setSHIBARate2Stop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[SHIBARate2Stop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!MATICStop){

                try {
                    const res = await axios.get('/api/nt-matic')

                    if(res.data[0].ID){
                        setNT_MATIC(res.data[0].matic)
                        setMATICStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[MATICStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!MATICRateStop){

                try {
                    const res = await axios.get('/api/nt-ratematic')

                    if(res.data[0].ID){
                        setNT_rateMATIC(res.data[0].matic)
                        setMATICRateStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[MATICRateStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!MATICProRateStop){

                try {
                    const res = await axios.get('/api/nt-proratematic')

                    if(res.data[0].ID){
                        setNT_ProrateMATIC(res.data[0].matic)
                        setMATICProRateStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[MATICProRateStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!MATICChargeStop){

                try {
                    const res = await axios.get('/api/nt-chargematic')

                    if(res.data[0].ID){
                        setNT_ChargeMATIC(res.data[0].matic)
                        setMATICChargeStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[MATICChargeStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!MATICRate2Stop){

                try {
                    const res = await axios.get('/api/nt-rate2matic')

                    if(res.data[0].ID){
                        setNT_rate2MATIC(res.data[0].matic)
                        setMATICRate2Stop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[MATICRate2Stop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!ETHStop){

                try {
                    const res = await axios.get('/api/nt-eth')

                    if(res.data[0].ID){
                        setNT_ETH(res.data[0].eth)
                        setETHStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[ETHStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!ETHRateStop){

                try {
                    const res = await axios.get('/api/nt-rateeth')

                    if(res.data[0].ID){
                        setNT_rateETH(res.data[0].eth)
                        setETHRateStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[ETHRateStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!ETHProRateStop){

                try {
                    const res = await axios.get('/api/nt-prorateeth')

                    if(res.data[0].ID){
                        setNT_ProrateETH(res.data[0].eth)
                        setETHProRateStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[ETHProRateStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!ETHChargeStop){

                try {
                    const res = await axios.get('/api/nt-chargeeth')

                    if(res.data[0].ID){
                        setNT_ChargeETH(res.data[0].eth)
                        setETHChargeStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[ETHChargeStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!ETHRate2Stop){

                try {
                    const res = await axios.get('/api/nt-rate2eth')

                    if(res.data[0].ID){
                        setNT_rate2ETH(res.data[0].eth)
                        setETHRate2Stop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[ETHRate2Stop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!LINKStop){

                try {
                    const res = await axios.get('/api/nt-link')

                    if(res.data[0].ID){
                        setNT_LINK(res.data[0].link)
                        setLINKStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[LINKStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!LINKRateStop){

                try {
                    const res = await axios.get('/api/nt-ratelink')

                    if(res.data[0].ID){
                        setNT_rateLINK(res.data[0].link)
                        setLINKRateStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[LINKRateStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!LINKProRateStop){

                try {
                    const res = await axios.get('/api/nt-proratelink')

                    if(res.data[0].ID){
                        setNT_ProrateLINK(res.data[0].link)
                        setLINKProRateStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[LINKProRateStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!LINKChargeStop){

                try {
                    const res = await axios.get('/api/nt-chargelink')

                    if(res.data[0].ID){
                        setNT_ChargeLINK(res.data[0].link)
                        setLINKChargeStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[LINKChargeStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!LINKRate2Stop){

                try {
                    const res = await axios.get('/api/nt-rate2link')

                    if(res.data[0].ID){
                        setNT_rate2LINK(res.data[0].link)
                        setLINKRate2Stop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[LINKRate2Stop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!DOTEStop){

                try {
                    const res = await axios.get('/api/nt-dote')

                    if(res.data[0].ID){
                        setNT_DOTE(res.data[0].dote)
                        setDOTEStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[DOTEStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!DOTERateStop){

                try {
                    const res = await axios.get('/api/nt-ratedote')

                    if(res.data[0].ID){
                        setNT_rateDOTE(res.data[0].dote)
                        setDOTERateStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[DOTERateStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!DOTEProRateStop){

                try {
                    const res = await axios.get('/api/nt-proratedote')

                    if(res.data[0].ID){
                        setNT_ProrateDOTE(res.data[0].dote)
                        setDOTEProRateStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[DOTEProRateStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!DOTEChargeStop){

                try {
                    const res = await axios.get('/api/nt-chargedote')

                    if(res.data[0].ID){
                        setNT_ChargeDOTE(res.data[0].dote)
                        setDOTEChargeStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[DOTEChargeStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!DOTERate2Stop){

                try {
                    const res = await axios.get('/api/nt-rate2dote')

                    if(res.data[0].ID){
                        setNT_rate2DOTE(res.data[0].dote)
                        setDOTERate2Stop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[DOTERate2Stop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!ADAStop){

                try {
                    const res = await axios.get('/api/nt-ada')

                    if(res.data[0].ID){
                        setNT_ADA(res.data[0].ada)
                        setADAStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[ADAStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!ADARateStop){

                try {
                    const res = await axios.get('/api/nt-rateada')

                    if(res.data[0].ID){
                        setNT_rateADA(res.data[0].ada)
                        setADARateStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[ADARateStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!ADAProRateStop){

                try {
                    const res = await axios.get('/api/nt-prorateada')

                    if(res.data[0].ID){
                        setNT_ProrateADA(res.data[0].ada)
                        setADAProRateStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[ADAProRateStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!ADAChargeStop){

                try {
                    const res = await axios.get('/api/nt-chargeada')

                    if(res.data[0].ID){
                        setNT_ChargeADA(res.data[0].ada)
                        setADAChargeStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[ADAChargeStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!ADARate2Stop){

                try {
                    const res = await axios.get('/api/nt-rate2ada')

                    if(res.data[0].ID){
                        setNT_rate2ADA(res.data[0].ada)
                        setADARate2Stop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[ADARate2Stop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!SOLStop){

                try {
                    const res = await axios.get('/api/nt-sol')

                    if(res.data[0].ID){
                        setNT_SOL(res.data[0].sol)
                        setSOLStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[SOLStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!SOLRateStop){

                try {
                    const res = await axios.get('/api/nt-ratesol')

                    if(res.data[0].ID){
                        setNT_rateSOL(res.data[0].sol)
                        setSOLRateStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[SOLRateStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!SOLProRateStop){

                try {
                    const res = await axios.get('/api/nt-proratesol')

                    if(res.data[0].ID){
                        setNT_ProrateSOL(res.data[0].sol)
                        setSOLProRateStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[SOLProRateStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!SOLChargeStop){

                try {
                    const res = await axios.get('/api/nt-chargesol')

                    if(res.data[0].ID){
                        setNT_ChargeSOL(res.data[0].sol)
                        setSOLChargeStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[SOLChargeStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!SOLRate2Stop){

                try {
                    const res = await axios.get('/api/nt-rate2sol')

                    if(res.data[0].ID){
                        setNT_rate2SOL(res.data[0].sol)
                        setSOLRate2Stop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[SOLRate2Stop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!PMStop){

                try {
                    const res = await axios.get('/api/nt-pm')

                    if(res.data[0].ID){
                        setNT_PM(res.data[0].pm)
                        setPMStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[PMStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!PMRateStop){

                try {
                    const res = await axios.get('/api/nt-ratepm')

                    if(res.data[0].ID){
                        setNT_ratePM(res.data[0].pm)
                        setPMRateStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[PMRateStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!PMProRateStop){

                try {
                    const res = await axios.get('/api/nt-proratepm')

                    if(res.data[0].ID){
                        setNT_ProratePM(res.data[0].pm)
                        setPMProRateStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[PMProRateStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!PMChargeStop){

                try {
                    const res = await axios.get('/api/nt-chargepm')

                    if(res.data[0].ID){
                        setNT_ChargePM(res.data[0].pm)
                        setPMChargeStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[PMChargeStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!PMRate2Stop){

                try {
                    const res = await axios.get('/api/nt-rate2pm')

                    if(res.data[0].ID){
                        setNT_rate2PM(res.data[0].pm)
                        setPMRate2Stop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[PMRate2Stop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!BNBStop){

                try {
                    const res = await axios.get('/api/nt-bnb')

                    if(res.data[0].ID){
                        setNT_BNB(res.data[0].bnb)
                        setBNBStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[BNBStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!BNBRateStop){

                try {
                    const res = await axios.get('/api/nt-ratebnb')

                    if(res.data[0].ID){
                        setNT_rateBNB(res.data[0].bnb)
                        setBNBRateStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[BNBRateStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!BNBProRateStop){

                try {
                    const res = await axios.get('/api/nt-proratebnb')

                    if(res.data[0].ID){
                        setNT_ProrateBNB(res.data[0].bnb)
                        setBNBProRateStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[BNBProRateStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!BNBChargeStop){

                try {
                    const res = await axios.get('/api/nt-Chargebnb')

                    if(res.data[0].ID){
                        setNT_ChargeBNB(res.data[0].bnb)
                        setBNBChargeStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[BNBChargeStop])
    
    useEffect(()=>{

        const fetchData = async () => {

            if(!BNBRate2Stop){

                try {
                    const res = await axios.get('/api/nt-rate2bnb')

                    if(res.data[0].ID){
                        setNT_rate2BNB(res.data[0].bnb)
                        setBNBRate2Stop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[BNBRate2Stop])


  return (
    <div className='container mt-5'>
        {/* <div>
            <span onClick={forAllHandler} className='pointer'>Voir Info</span>
        </div> */}
        <div className={`${themeMode === "true" ? "row final-seesion-t" : "row final-seesion"}`}>
            <div className='center'>
                <div><span className={`${themeMode === "true" ? "color-or" : ""}`}>Données variantes des <strong>valeurs en dollar</strong></span></div>
                <hr className={`${themeMode === "true" ? "color-or" : ""}`}/>
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${btc}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Bitcoin</span>
                        {
                            BTCModif ? <span className='ml-2 stat-see-card-detail' onClick={validateBTCHandler}>Valider</span> :
                            <span className='ml-2 stat-see-card-detail' onClick={customBTCHandler}>Modifier</span>
                        }
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                BTCModif ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="btc" label="XXXXX BTC" name="btc" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : <div>$ {(NT_BTC*1).toFixed(2)}</div>
                            } 
                        </div>
                    </div>
                </div>
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${tron}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Tron</span>
                        {
                            TRONModif ? <span className='ml-2 stat-see-card-detail' onClick={validateTRONHandler}>Valider</span> :
                            <span className='ml-2 stat-see-card-detail' onClick={customTRONHandler}>Modifier</span>
                        }
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                TRONModif ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="tron" label="XXXXX TRX" name="tron" autoFocus onChange={currencyHandleChange} />
                                    </Box>
                                </div> : <div>$ {(NT_TRON*1).toFixed(5)}</div>
                            } 
                        </div>
                    </div>
                </div>  
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${ltc}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Litecoin</span>
                        {
                            LTCModif ? <span className='ml-2 stat-see-card-detail' onClick={validateLTCHandler}>Valider</span> :
                            <span className='ml-2 stat-see-card-detail' onClick={customLTCHandler}>Modifier</span>
                        }
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                LTCModif ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="ltc" label="XXXXX LTC" name="ltc" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : <div>$ {(NT_LTC*1).toFixed(2)}</div>
                            } 
                        </div>
                    </div>
                </div>  
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${usdt}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Tether</span>
                        {
                            USDTModif ? <span className='ml-2 stat-see-card-detail' onClick={validateUSDTHandler}>Valider</span> :
                            <span className='ml-2 stat-see-card-detail' onClick={customUSDTHandler}>Modifier</span>
                        }
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                USDTModif ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="usdt" label="XXXXX USDT" name="usdt" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : <div>$ {(NT_USDT*1).toFixed(5)}</div>
                            } 
                        </div>
                    </div>
                </div> 
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${doge}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Dogecoin</span>
                        {
                            DOGEModif ? <span className='ml-2 stat-see-card-detail' onClick={validateDOGEHandler}>Valider</span> :
                            <span className='ml-2 stat-see-card-detail' onClick={customDOGEHandler}>Modifier</span>
                        }
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                DOGEModif ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="doge" label="XXXXX DOGE" name="doge" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : <div>$ {(NT_DOGE*1).toFixed(5)}</div>
                            } 
                        </div>
                    </div>
                </div> 
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${busd}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Binance usd</span>
                        {
                            BUSDModif ? <span className='ml-2 stat-see-card-detail' onClick={validateBUSDHandler}>Valider</span> :
                            <span className='ml-2 stat-see-card-detail' onClick={customBUSDHandler}>Modifier</span>
                        }
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                BUSDModif ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="busd" label="XXXXX BUSD" name="busd" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : <div>$ {(NT_BUSD*1).toFixed(4)}</div>
                            } 
                        </div>
                    </div>
                </div> 
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${shiba}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Shiba</span>
                        {
                            SHIBAModif ? <span className='ml-2 stat-see-card-detail' onClick={validateSHIBAHandler}>Valider</span> :
                            <span className='ml-2 stat-see-card-detail' onClick={customSHIBAHandler}>Modifier</span>
                        }
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                SHIBAModif ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="shiba" label="XXXXX SHIBA" name="shiba" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : <div>$ {(NT_SHIBA*1).toFixed(9)}</div>
                            } 
                        </div>
                    </div>
                </div> 
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${polygonmatic}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Polygon matic</span>
                        {
                            MATICModif ? <span className='ml-2 stat-see-card-detail' onClick={validateMATICHandler}>Valider</span> :
                            <span className='ml-2 stat-see-card-detail' onClick={customMATICHandler}>Modifier</span>
                        }
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                MATICModif ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="matic" label="XXXXX MATIC" name="matic" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : <div>$ {(NT_MATIC*1).toFixed(4)}</div>
                            } 
                        </div>
                    </div>
                </div> 
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${ethereum}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Ethereum</span>
                        {
                            ETHModif ? <span className='ml-2 stat-see-card-detail' onClick={validateETHHandler}>Valider</span> :
                            <span className='ml-2 stat-see-card-detail' onClick={customETHHandler}>Modifier</span>
                        }
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                ETHModif ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="ethereum" label="XXXXX ETH" name="ethereum" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : <div>$ {(NT_ETH*1).toFixed(2)}</div>
                            } 
                        </div>
                    </div>
                </div> 
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${chainlink}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Chain link</span>
                        {
                            LINKModif ? <span className='ml-2 stat-see-card-detail' onClick={validateLINKHandler}>Valider</span> :
                            <span className='ml-2 stat-see-card-detail' onClick={customLINKHandler}>Modifier</span>
                        }
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                LINKModif ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="chainlink" label="XXXXX LINK" name="chainlink" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : <div>$ {(NT_LINK*1).toFixed(2)}</div>
                            } 
                        </div>
                    </div>
                </div> 
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${polkadot}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Polkadot</span>
                        {
                            DOTModif ? <span className='ml-2 stat-see-card-detail' onClick={validateDOTHandler}>Valider</span> :
                            <span className='ml-2 stat-see-card-detail' onClick={customDOTHandler}>Modifier</span>
                        }
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                DOTModif ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="polkadot" label="XXXXX DOT" name="polkadot" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : <div>$ {(NT_DOTE*1).toFixed(2)}</div>
                            } 
                        </div>
                    </div>
                </div> 
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${cardano}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Cardano</span>
                        {
                            ADAModif ? <span className='ml-2 stat-see-card-detail' onClick={validateADAHandler}>Valider</span> :
                            <span className='ml-2 stat-see-card-detail' onClick={customADAHandler}>Modifier</span>
                        }
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                ADAModif ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="cardano" label="XXXXX ADA" name="cardano" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : <div>$ {(NT_ADA*1).toFixed(4)}</div>
                            } 
                        </div>
                    </div>
                </div> 
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${solana}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Solana</span>
                        {
                            SOLModif ? <span className='ml-2 stat-see-card-detail' onClick={validateSOLHandler}>Valider</span> :
                            <span className='ml-2 stat-see-card-detail' onClick={customSOLHandler}>Modifier</span>
                        }
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                SOLModif ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="solana" label="XXXXX SOL" name="solana" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : <div>$ {(NT_SOL*1).toFixed(2)}</div>
                            } 
                        </div>
                    </div>
                </div> 
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${pm}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Perfect Money</span>
                        {
                            PMModif ? <span className='ml-2 stat-see-card-detail' onClick={validatePMHandler}>Valider</span> :
                            <span className='ml-2 stat-see-card-detail' onClick={customPMHandler}>Modifier</span>
                        }
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                PMModif ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="pm" label="XXXXX PM" name="pm" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : <div>$ {(NT_PM*1).toFixed(2)}</div>
                            } 
                        </div>
                    </div>
                </div> 
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${bnb}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Binance Smart Chain</span>
                        {
                            BNBModif ? <span className='ml-2 stat-see-card-detail' onClick={validateBNBHandler}>Valider</span> :
                            <span className='ml-2 stat-see-card-detail' onClick={customBNBHandler}>Modifier</span>
                        }
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                BNBModif ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="bnb" label="XXXXX BNB" name="bnb" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : <div>$ {(NT_BNB*1).toFixed(2)}</div>
                            } 
                        </div>
                    </div>
                </div> 
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        {/* <img className='images-drapeau mr-2' src={`../${bnb}`} alt="" /> */}
                        {/* <span className='ml-2 stat-see-card-detail'>Binance Smart Chain</span> */}
                        {/* {
                            BNBModif ? <span className='ml-2 stat-see-card-detail' onClick={validateBNBHandler}>Valider</span> :
                            <span className='ml-2 stat-see-card-detail' onClick={customBNBHandler}>Modifier</span>
                        } */}
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {/* {
                                BNBModif ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="bnb" label="XXXXX BNB" name="bnb" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : <div>$ {(NT_BNB*1).toFixed(2)}</div>
                            }  */}
                        </div>
                    </div>
                </div> 
            </div>
        </div>


        <div className={`${themeMode === "true" ? "row mt-3 final-seesion-t" : "row mt-3 final-seesion"}`}>
            <div className='center'>
                <div><span className={`${themeMode === "true" ? "color-or" : ""}`}>Données variantes des <strong>charges standardes</strong></span></div>
                <hr className={`${themeMode === "true" ? "color-or" : ""}`}/>
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${btc}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Bitcoin</span>
                        {BTCModifRate ? <span className='stat-see-card-detail-achat' onClick={validateBTCRateHandler}>Valider</span> : null}
                        {BTCModifRate2 ? <span className='stat-see-card-detail-achat' onClick={validateBTCRate2Handler}>Valider</span> : null}
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                BTCModifRate ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="btc" label="XXXXX BTC" name="btc" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                BTCModifRate2 ? null :
                                <div>
                                    <span className='stat-see-card-detail-achat' onClick={customRateBTCHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>{NT_rateBTC} XOF</span>
                                </div>
                            } 
                            {
                                BTCModifRate2 ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="btc" label="XXXXX BTC" name="btc" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                BTCModifRate ? null :
                                <div>
                                    <span className='stat-see-card-detail-vente' onClick={customRate2BTCHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>{NT_rate2BTC} XOF</span>
                                </div>
                            } 
                        </div>
                    </div>
                </div>
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${tron}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Tron</span>
                        {TRONModifRate ? <span className='stat-see-card-detail-achat' onClick={validateRateTRONHandler}>Valider</span> : null}
                        {TRONModifRate2 ? <span className='stat-see-card-detail-achat' onClick={validateRate2TRONHandler}>Valider</span> : null}
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                TRONModifRate ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="tron" label="XXXXX TRON" name="tron" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                TRONModifRate2 ? null :
                                <div>
                                    <span className='stat-see-card-detail-achat' onClick={customRateTRONHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>{NT_rateTRON} XOF</span>
                                </div>
                            } 
                            {
                                TRONModifRate2 ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="tron" label="XXXXX TRON" name="tron" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                TRONModifRate ? null :
                                <div>
                                    <span className='stat-see-card-detail-vente' onClick={customRate2TRONHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>{NT_rate2TRON} XOF</span>
                                </div>
                            } 
                        </div>
                    </div>
                </div>  
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${ltc}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Litecoin</span>
                        {LTCModifRate ? <span className='stat-see-card-detail-achat' onClick={validateRateLTCHandler}>Valider</span> : null}
                        {LTCModifRate2 ? <span className='stat-see-card-detail-achat' onClick={validateRate2LTCHandler}>Valider</span> : null}
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                LTCModifRate ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="ltc" label="XXXXX LTC" name="ltc" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                LTCModifRate2 ? null:
                                <div>
                                    <span className='stat-see-card-detail-achat' onClick={customRateLTCHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>{NT_rateLTC} XOF</span>
                                </div>
                            } 
                            {
                                LTCModifRate2 ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="ltc" label="XXXXX LTC" name="ltc" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                LTCModifRate ? null:
                                <div>
                                    <span className='stat-see-card-detail-vente' onClick={customRate2LTCHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>{NT_rate2LTC} XOF</span>
                                </div>
                            } 
                        </div>
                    </div>
                </div>  
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${usdt}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Tether</span>
                        {USDTModifRate ? <span className='stat-see-card-detail-achat' onClick={validateRateUSDTHandler}>Valider</span> : null}
                        {USDTModifRate2 ? <span className='stat-see-card-detail-achat' onClick={validateRate2USDTHandler}>Valider</span> : null}
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                USDTModifRate ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="usdt" label="XXXXX USDT" name="usdt" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                USDTModifRate2 ? null :
                                <div>
                                    <span className='stat-see-card-detail-achat' onClick={customRateUSDTHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>{NT_rateUSDT} XOF</span>
                                </div>
                            } 
                            {
                                USDTModifRate2 ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="usdt" label="XXXXX USDT" name="usdt" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                USDTModifRate ? null :
                                <div>
                                    <span className='stat-see-card-detail-vente' onClick={customRate2USDTHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>{NT_rate2USDT} XOF</span>
                                </div>
                            }
                        </div>
                    </div>
                </div> 
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${doge}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Dogecoin</span>
                        {DOGEModifRate ? <span className='stat-see-card-detail-achat' onClick={validateRateDOGEHandler}>Valider</span> : null}
                        {DOGEModifRate2 ? <span className='stat-see-card-detail-achat' onClick={validateRate2DOGEHandler}>Valider</span> : null}
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                DOGEModifRate ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="doge" label="XXXXX DOGE" name="doge" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                DOGEModifRate2 ? null :
                                <div>
                                    <span className='stat-see-card-detail-achat' onClick={customRateDOGEHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>{NT_rateDOGE} XOF</span>
                                </div>
                            } 
                            {
                                DOGEModifRate2 ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="doge" label="XXXXX DOGE" name="doge" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                DOGEModifRate ? null :
                                <div>
                                    <span className='stat-see-card-detail-vente' onClick={customRate2DOGEHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>{NT_rate2DOGE} XOF</span>
                                </div>
                            }
                        </div>
                    </div>
                </div> 
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${busd}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Binance usd</span>
                        {BUSDModifRate ? <span className='stat-see-card-detail-achat' onClick={validateRateBUSDHandler}>Valider</span> : null}
                        {BUSDModifRate2 ? <span className='stat-see-card-detail-achat' onClick={validateRate2BUSDHandler}>Valider</span> : null}
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                BUSDModifRate ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="busd" label="XXXXX BUSD" name="busd" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                BUSDModifRate2 ? null :
                                <div>
                                    <span className='stat-see-card-detail-achat' onClick={customRateBUSDHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>{NT_rateBUSD} XOF</span>
                                </div>
                            } 
                            {
                                BUSDModifRate2 ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="busd" label="XXXXX BUSD" name="busd" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                BUSDModifRate ? null :
                                <div>
                                    <span className='stat-see-card-detail-vente' onClick={customRate2BUSDHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>{NT_rate2BUSD} XOF</span>
                                </div>
                            }
                        </div>
                    </div>
                </div> 
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${shiba}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Shiba</span>
                        {SHIBAModifRate ? <span className='stat-see-card-detail-achat' onClick={validateRateSHIBAHandler}>Valider</span> : null}
                        {SHIBAModifRate2 ? <span className='stat-see-card-detail-achat' onClick={validateRate2SHIBAHandler}>Valider</span> : null}
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                SHIBAModifRate ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="shiba" label="XXXXX SHIBA" name="shiba" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                SHIBAModifRate2 ? null :
                                <div>
                                    <span className='stat-see-card-detail-achat' onClick={customRateSHIBAHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>{NT_rateSHIBA} XOF</span>
                                </div>
                            } 
                            {
                                SHIBAModifRate2 ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="shiba" label="XXXXX SHIBA" name="shiba" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                SHIBAModifRate ? null :
                                <div>
                                    <span className='stat-see-card-detail-vente' onClick={customRate2SHIBAHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>{NT_rate2SHIBA} XOF</span>
                                </div>
                            }
                        </div>
                    </div>
                </div> 
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${polygonmatic}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Polygon matic</span>
                        {MATICModifRate ? <span className='stat-see-card-detail-achat' onClick={validateRateMATICHandler}>Valider</span> : null}
                        {MATICModifRate2 ? <span className='stat-see-card-detail-achat' onClick={validateRate2MATICHandler}>Valider</span> : null}
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                MATICModifRate ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="matic" label="XXXXX MATIC" name="matic" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                MATICModifRate2 ? null : 
                                <div>
                                    <span className='stat-see-card-detail-achat' onClick={customRateMATICHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>{NT_rateMATIC} XOF</span>
                                </div>
                            } 
                            {
                                MATICModifRate2 ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="matic" label="XXXXX MATIC" name="matic" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                MATICModifRate ? null : 
                                <div>
                                    <span className='stat-see-card-detail-vente' onClick={customRate2MATICHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>{NT_rate2MATIC} XOF</span>
                                </div>
                            }
                        </div>
                    </div>
                </div> 
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${ethereum}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Ethereum</span>
                        {ETHModifRate ? <span className='stat-see-card-detail-achat' onClick={validateRateETHHandler}>Valider</span> : null}
                        {ETHModifRate2 ? <span className='stat-see-card-detail-achat' onClick={validateRate2ETHHandler}>Valider</span> : null}
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                ETHModifRate ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="eth" label="XXXXX ETH" name="eth" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                ETHModifRate2 ? null : 
                                <div>
                                    <span className='stat-see-card-detail-achat' onClick={customRateETHHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>{NT_rateETH} XOF</span>
                                </div>
                            } 
                            {
                                ETHModifRate2 ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="eth" label="XXXXX ETH" name="eth" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                ETHModifRate ? null : 
                                <div>
                                    <span className='stat-see-card-detail-vente' onClick={customRate2ETHHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>{NT_rate2ETH} XOF</span>
                                </div>
                            }
                        </div>
                    </div>
                </div> 
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${chainlink}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Chain link</span>
                        {LINKModifRate ? <span className='stat-see-card-detail-achat' onClick={validateRateLINKHandler}>Valider</span> : null}
                        {LINKModifRate2 ? <span className='stat-see-card-detail-achat' onClick={validateRate2LINKHandler}>Valider</span> : null}
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                LINKModifRate ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="link" label="XXXXX LINK" name="link" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                LINKModifRate2 ? null :
                                <div>
                                    <span className='stat-see-card-detail-achat' onClick={customRateLINKHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>{NT_rateLINK} XOF</span>
                                </div>
                            } 
                            {
                                LINKModifRate2 ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="link" label="XXXXX LINK" name="link" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                LINKModifRate ? null :
                                <div>
                                    <span className='stat-see-card-detail-vente' onClick={customRate2LINKHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>{NT_rate2LINK} XOF</span>
                                </div>
                            }
                        </div>
                    </div>
                </div> 
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${polkadot}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Polkadot</span>
                        {DOTModifRate ? <span className='stat-see-card-detail-achat' onClick={validateRateDOTHandler}>Valider</span> : null}
                        {DOTModifRate2 ? <span className='stat-see-card-detail-achat' onClick={validateRate2DOTHandler}>Valider</span> : null}
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                DOTModifRate ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="dot" label="XXXXX DOT" name="dot" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                DOTModifRate2 ? null :
                                <div>
                                    <span className='stat-see-card-detail-achat' onClick={customRateDOTHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>{NT_rateDOTE} XOF</span>
                                </div>
                            } 
                            {
                                DOTModifRate2 ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="dot" label="XXXXX DOT" name="dot" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                DOTModifRate ? null :
                                <div>
                                    <span className='stat-see-card-detail-vente' onClick={customRate2DOTHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>{NT_rate2DOTE} XOF</span>
                                </div>
                            }
                        </div>
                    </div>
                </div> 
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${cardano}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Cardano</span>
                        {ADAModifRate ? <span className='stat-see-card-detail-achat' onClick={validateRateADAHandler}>Valider</span> : null}
                        {ADAModifRate2 ? <span className='stat-see-card-detail-achat' onClick={validateRate2ADAHandler}>Valider</span> : null}
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'> 
                            {
                                ADAModifRate ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="ada" label="XXXXX ADA" name="ada" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                ADAModifRate2 ? null :
                                <div>
                                    <span className='stat-see-card-detail-achat' onClick={customRateADAHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>{NT_rateADA} XOF</span>
                                </div>
                            } 
                            {
                                ADAModifRate2 ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="ada" label="XXXXX ADA" name="ada" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                ADAModifRate ? null :
                                <div>
                                    <span className='stat-see-card-detail-vente' onClick={customRate2ADAHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>{NT_rate2ADA} XOF</span>
                                </div>
                            }
                        </div>
                    </div>
                </div> 
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${solana}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Solana</span>
                        {SOLModifRate ? <span className='stat-see-card-detail-achat' onClick={validateRateSOLHandler}>Valider</span> : null}
                        {SOLModifRate2 ? <span className='stat-see-card-detail-achat' onClick={validateRate2SOLHandler}>Valider</span> : null}
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                SOLModifRate ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="sol" label="XXXXX SOL" name="sol" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                SOLModifRate2 ? null :
                                <div>
                                    <span className='stat-see-card-detail-achat' onClick={customRateSOLHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>{NT_rateSOL} XOF</span>
                                </div>
                            } 
                            {
                                SOLModifRate2 ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="sol" label="XXXXX SOL" name="sol" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                SOLModifRate ? null :
                                <div>
                                    <span className='stat-see-card-detail-vente' onClick={customRate2SOLHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>{NT_rate2SOL} XOF</span>
                                </div>
                            }
                        </div>
                    </div>
                </div> 
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${pm}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Perfect Money</span>
                        {PMModifRate ? <span className='stat-see-card-detail-achat' onClick={validateRatePMHandler}>Valider</span> : null}
                        {PMModifRate2 ? <span className='stat-see-card-detail-achat' onClick={validateRate2PMHandler}>Valider</span> : null}
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                PMModifRate ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="pm" label="XXXXX PM" name="pm" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                PMModifRate2 ? null :
                                <div>
                                    <span className='stat-see-card-detail-achat' onClick={customRatePMHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>{NT_ratePM} XOF</span>
                                </div>
                            } 
                            {
                                PMModifRate2 ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="pm" label="XXXXX PM" name="pm" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                PMModifRate ? null :
                                <div>
                                    <span className='stat-see-card-detail-vente' onClick={customRate2PMHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>{NT_rate2PM} XOF</span>
                                </div>
                            }
                        </div>
                    </div>
                </div> 
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${bnb}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Binance Smart Chain</span>
                        {BNBModifRate ? <span className='stat-see-card-detail-achat' onClick={validateRateBNBHandler}>Valider</span> : null}
                        {BNBModifRate2 ? <span className='stat-see-card-detail-achat' onClick={validateRate2BNBHandler}>Valider</span> : null}
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                BNBModifRate ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="bnb" label="XXXXX BNB" name="bnb" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                BNBModifRate2 ? null :
                                <div>
                                    <span className='stat-see-card-detail-achat' onClick={customRateBNBHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>{NT_rateBNB} XOF</span>
                                </div>
                            } 
                            {
                                BNBModifRate2 ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="bnb" label="XXXXX BNB" name="bnb" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                BNBModifRate ? null :
                                <div>
                                    <span className='stat-see-card-detail-vente' onClick={customRate2BNBHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>{NT_rate2BNB} XOF</span>
                                </div>
                            }
                        </div>
                    </div>
                </div> 
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        {/* <img className='images-drapeau mr-2' src={`../${bnb}`} alt="" /> */}
                        {/* <span className='ml-2 stat-see-card-detail'>Binance Smart Chain</span> */}
                        {/* {
                            BNBModif ? <span className='ml-2 stat-see-card-detail' onClick={validateBNBHandler}>Valider</span> :
                            <span className='ml-2 stat-see-card-detail' onClick={customBNBHandler}>Modifier</span>
                        } */}
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {/* {
                                BNBModif ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="bnb" label="XXXXX BNB" name="bnb" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : <div>$ {(NT_BNB*1).toFixed(2)}</div>
                            }  */}
                        </div>
                    </div>
                </div> 
            </div>
        </div>


        <div className={`${themeMode === "true" ? "row mt-3 final-seesion-t" : "row mt-3 final-seesion"}`}>
            <div className='center'>
                <div><span className={`${themeMode === "true" ? "color-or" : ""}`}>Données variantes des <strong>charges professionnelles</strong></span></div>
                <hr className={`${themeMode === "true" ? "color-or" : ""}`}/>
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${btc}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Bitcoin</span>
                        {BTCModifProRate ? <span className='stat-see-card-detail-achat' onClick={validateBTCProRateHandler}>Valider</span> : null}
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                BTCModifProRate ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="btc" label="XXXXX BTC" name="btc" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                <div>
                                    <span className='stat-see-card-detail-achat' onClick={customProRateBTCHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>{NT_ProrateBTC} XOF</span>
                                </div>
                            } 
                        </div>
                    </div>
                </div>
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${tron}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Tron</span>
                        {TRONModifProRate ? <span className='stat-see-card-detail-achat' onClick={validateProRateTRONHandler}>Valider</span> : null}
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                TRONModifProRate ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="tron" label="XXXXX TRON" name="tron" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                <div>
                                    <span className='stat-see-card-detail-achat' onClick={customProRateTRONHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>{NT_ProrateTRON} XOF</span>
                                </div>
                            }
                        </div>
                    </div>
                </div>  
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${ltc}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Litecoin</span>
                        {LTCModifProRate ? <span className='stat-see-card-detail-achat' onClick={validateProRateLTCHandler}>Valider</span> : null}
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                LTCModifProRate ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="ltc" label="XXXXX LTC" name="ltc" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                <div>
                                    <span className='stat-see-card-detail-achat' onClick={customProRateLTCHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>{NT_ProrateLTC} XOF</span>
                                </div>
                            }
                        </div>
                    </div>
                </div>  
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${usdt}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Tether</span>
                        {USDTModifProRate ? <span className='stat-see-card-detail-achat' onClick={validateProRateUSDTHandler}>Valider</span> : null}
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                USDTModifProRate ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="usdt" label="XXXXX USDT" name="usdt" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                <div>
                                    <span className='stat-see-card-detail-achat' onClick={customProRateUSDTHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>{NT_ProrateUSDT} XOF</span>
                                </div>
                            }
                        </div>
                    </div>
                </div> 
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${doge}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Dogecoin</span>
                        {DOGEModifProRate ? <span className='stat-see-card-detail-achat' onClick={validateProRateDOGEHandler}>Valider</span> : null}
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                DOGEModifProRate ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="doge" label="XXXXX DOGE" name="doge" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                <div>
                                    <span className='stat-see-card-detail-achat' onClick={customProRateDOGEHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>{NT_ProrateDOGE} XOF</span>
                                </div>
                            }
                        </div>
                    </div>
                </div> 
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${busd}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Binance usd</span>
                        {BUSDModifProRate ? <span className='stat-see-card-detail-achat' onClick={validateProRateBUSDHandler}>Valider</span> : null}
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                BUSDModifProRate ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="busd" label="XXXXX BUSD" name="busd" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                <div>
                                    <span className='stat-see-card-detail-achat' onClick={customProRateBUSDHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>{NT_ProrateBUSD} XOF</span>
                                </div>
                            }
                        </div>
                    </div>
                </div> 
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${shiba}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Shiba</span>
                        {SHIBAModifProRate ? <span className='stat-see-card-detail-achat' onClick={validateProRateSHIBAHandler}>Valider</span> : null}
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                SHIBAModifProRate ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="shiba" label="XXXXX SHIBA" name="shiba" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                <div>
                                    <span className='stat-see-card-detail-achat' onClick={customProRateSHIBAHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>{NT_ProrateSHIBA} XOF</span>
                                </div>
                            }
                        </div>
                    </div>
                </div> 
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${polygonmatic}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Polygon matic</span>
                        {MATICModifProRate ? <span className='stat-see-card-detail-achat' onClick={validateProRateMATICHandler}>Valider</span> : null}
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                MATICModifProRate ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="matic" label="XXXXX MATIC" name="matic" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                <div>
                                    <span className='stat-see-card-detail-achat' onClick={customProRateMATICHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>{NT_ProrateMATIC} XOF</span>
                                </div>
                            }
                        </div>
                    </div>
                </div> 
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${ethereum}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Ethereum</span>
                        {ETHModifProRate ? <span className='stat-see-card-detail-achat' onClick={validateProRateETHHandler}>Valider</span> : null}
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                ETHModifProRate ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="eth" label="XXXXX ETH" name="eth" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                <div>
                                    <span className='stat-see-card-detail-achat' onClick={customProRateETHHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>{NT_ProrateETH} XOF</span>
                                </div>
                            }
                        </div>
                    </div>
                </div> 
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${chainlink}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Chain link</span>
                        {LINKModifProRate ? <span className='stat-see-card-detail-achat' onClick={validateProRateLINKHandler}>Valider</span> : null}
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                LINKModifProRate ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="link" label="XXXXX LINK" name="link" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                <div>
                                    <span className='stat-see-card-detail-achat' onClick={customProRateLINKHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>{NT_ProrateLINK} XOF</span>
                                </div>
                            }
                        </div>
                    </div>
                </div> 
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${polkadot}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Polkadot</span>
                        {DOTModifProRate ? <span className='stat-see-card-detail-achat' onClick={validateProRateDOTHandler}>Valider</span> : null}
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                DOTModifProRate ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="dot" label="XXXXX DOT" name="dot" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                <div>
                                    <span className='stat-see-card-detail-achat' onClick={customProRateDOTHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>{NT_ProrateDOTE} XOF</span>
                                </div>
                            }
                        </div>
                    </div>
                </div> 
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${cardano}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Cardano</span>
                        {ADAModifProRate ? <span className='stat-see-card-detail-achat' onClick={validateProRateADAHandler}>Valider</span> : null}
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'> 
                            {
                                ADAModifProRate ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="ada" label="XXXXX ADA" name="ada" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                <div>
                                    <span className='stat-see-card-detail-achat' onClick={customProRateADAHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>{NT_ProrateADA} XOF</span>
                                </div>
                            }
                        </div>
                    </div>
                </div> 
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${solana}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Solana</span>
                        {SOLModifProRate ? <span className='stat-see-card-detail-achat' onClick={validateProRateSOLHandler}>Valider</span> : null}
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                SOLModifProRate ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="sol" label="XXXXX SOL" name="sol" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                <div>
                                    <span className='stat-see-card-detail-achat' onClick={customProRateSOLHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>{NT_ProrateSOL} XOF</span>
                                </div>
                            }
                        </div>
                    </div>
                </div> 
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${pm}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Perfect Money</span>
                        {PMModifProRate ? <span className='stat-see-card-detail-achat' onClick={validateProRatePMHandler}>Valider</span> : null}
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                PMModifProRate ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="pm" label="XXXXX PM" name="pm" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                <div>
                                    <span className='stat-see-card-detail-achat' onClick={customProRatePMHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>{NT_ProratePM} XOF</span>
                                </div>
                            }
                        </div>
                    </div>
                </div> 
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${bnb}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Binance Smart Chain</span>
                        {BNBModifProRate ? <span className='stat-see-card-detail-achat' onClick={validateProRateBNBHandler}>Valider</span> : null}
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                BNBModifProRate ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="bnb" label="XXXXX BNB" name="bnb" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                <div>
                                    <span className='stat-see-card-detail-achat' onClick={customProRateBNBHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>{NT_ProrateBNB} XOF</span>
                                </div>
                            }
                        </div>
                    </div>
                </div> 
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        {/* <img className='images-drapeau mr-2' src={`../${bnb}`} alt="" /> */}
                        {/* <span className='ml-2 stat-see-card-detail'>Binance Smart Chain</span> */}
                        {/* {
                            BNBModif ? <span className='ml-2 stat-see-card-detail' onClick={validateBNBHandler}>Valider</span> :
                            <span className='ml-2 stat-see-card-detail' onClick={customBNBHandler}>Modifier</span>
                        } */}
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {/* {
                                BNBModif ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="bnb" label="XXXXX BNB" name="bnb" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : <div>$ {(NT_BNB*1).toFixed(2)}</div>
                            }  */}
                        </div>
                    </div>
                </div> 
            </div>
        </div>

        <div><span className='ml-2 stat-see-card-detail' onClick={validateCreateChargeBNBHandler}>Créer</span></div>


        <div className={`${themeMode === "true" ? "row mt-3 final-seesion-t" : "row mt-3 final-seesion"}`}>
            <div className='center'>
                <div><span className={`${themeMode === "true" ? "color-or" : ""}`}>Données variantes des <strong>charges de couverture</strong></span></div>
                <hr className={`${themeMode === "true" ? "color-or" : ""}`}/>
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${btc}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Bitcoin (<strong style={{color:"#ff2020"}}>couv+</strong>)</span>
                        {BTCModifCharge ? <span className='stat-see-card-detail-achat' onClick={validateBTCChargeHandler}>Valider</span> : null}
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                BTCModifCharge ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="btc" label="XXXXX BTC" name="btc" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                <div>
                                    <span className='stat-see-card-detail-achat' onClick={customChargeBTCHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>$ {NT_ChargeBTC}</span>
                                </div>
                            } 
                        </div>
                    </div>
                </div>
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${tron}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Tron (<strong style={{color:"#ff2020"}}>couv+</strong>)</span>
                        {TRONModifCharge ? <span className='stat-see-card-detail-achat' onClick={validateChargeTRONHandler}>Valider</span> : null}
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                TRONModifCharge ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="tron" label="XXXXX TRON" name="tron" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                <div>
                                    <span className='stat-see-card-detail-achat' onClick={customChargeTRONHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>$ {NT_ChargeTRON}</span>
                                </div>
                            }
                        </div>
                    </div>
                </div>  
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${ltc}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Litecoin (<strong style={{color:"#ff2020"}}>couv+</strong>)</span>
                        {LTCModifCharge ? <span className='stat-see-card-detail-achat' onClick={validateChargeLTCHandler}>Valider</span> : null}
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                LTCModifCharge ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="ltc" label="XXXXX LTC" name="ltc" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                <div>
                                    <span className='stat-see-card-detail-achat' onClick={customChargeLTCHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>$ {NT_ChargeLTC}</span>
                                </div>
                            }
                        </div>
                    </div>
                </div>  
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${usdt}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Tether (<strong style={{color:"#ff2020"}}>couv+</strong>)</span>
                        {USDTModifCharge ? <span className='stat-see-card-detail-achat' onClick={validateChargeUSDTHandler}>Valider</span> : null}
                        {USDTModifCharge2 ? <span className='stat-see-card-detail-achat' onClick={validateCharge2USDTHandler}>Valider</span> : null}
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                USDTModifCharge ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="usdt" label="XXXXX USDT" name="usdt" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : USDTModifCharge2 ? null :
                                <div>
                                    <span className='stat-see-card-detail-achat' onClick={customChargeUSDTHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>$ {NT_ChargeUSDT} (trc20)</span>
                                </div>
                            }
                        </div>
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                USDTModifCharge2 ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="usdt" label="XXXXX USDT" name="usdt" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : USDTModifCharge ? null :
                                <div>
                                    <span className='stat-see-card-detail-achat' onClick={customCharge2USDTHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>$ {NT_Charge2USDT} (bep20)</span>
                                </div>
                            }
                        </div>
                    </div>
                </div> 
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${doge}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Dogecoin (<strong style={{color:"#ff2020"}}>couv+</strong>)</span>
                        {DOGEModifCharge ? <span className='stat-see-card-detail-achat' onClick={validateChargeDOGEHandler}>Valider</span> : null}
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                DOGEModifCharge ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="doge" label="XXXXX DOGE" name="doge" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                <div>
                                    <span className='stat-see-card-detail-achat' onClick={customChargeDOGEHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>$ {NT_ChargeDOGE}</span>
                                </div>
                            }
                        </div>
                    </div>
                </div> 
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${busd}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Binance usd (<strong style={{color:"#ff2020"}}>couv+</strong>)</span>
                        {BUSDModifCharge ? <span className='stat-see-card-detail-achat' onClick={validateChargeBUSDHandler}>Valider</span> : null}
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                BUSDModifCharge ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="busd" label="XXXXX BUSD" name="busd" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                <div>
                                    <span className='stat-see-card-detail-achat' onClick={customChargeBUSDHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>$ {NT_ChargeBUSD}</span>
                                </div>
                            }
                        </div>
                    </div>
                </div> 
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${shiba}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Shiba (<strong style={{color:"#ff2020"}}>couv+</strong>)</span>
                        {SHIBAModifCharge ? <span className='stat-see-card-detail-achat' onClick={validateChargeSHIBAHandler}>Valider</span> : null}
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                SHIBAModifCharge ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="shiba" label="XXXXX SHIBA" name="shiba" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                <div>
                                    <span className='stat-see-card-detail-achat' onClick={customChargeSHIBAHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>$ {NT_ChargeSHIBA}</span>
                                </div>
                            }
                        </div>
                    </div>
                </div> 
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${polygonmatic}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Polygon matic (<strong style={{color:"#ff2020"}}>couv+</strong>)</span>
                        {MATICModifCharge ? <span className='stat-see-card-detail-achat' onClick={validateChargeMATICHandler}>Valider</span> : null}
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                MATICModifCharge ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="matic" label="XXXXX MATIC" name="matic" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                <div>
                                    <span className='stat-see-card-detail-achat' onClick={customChargeMATICHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>$ {NT_ChargeMATIC}</span>
                                </div>
                            }
                        </div>
                    </div>
                </div> 
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${ethereum}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Ethereum (<strong style={{color:"#ff2020"}}>couv+</strong>)</span>
                        {ETHModifCharge ? <span className='stat-see-card-detail-achat' onClick={validateChargeETHHandler}>Valider</span> : null}
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                ETHModifCharge ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="eth" label="XXXXX ETH" name="eth" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                <div>
                                    <span className='stat-see-card-detail-achat' onClick={customChargeETHHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>$ {NT_ChargeETH}</span>
                                </div>
                            }
                        </div>
                    </div>
                </div> 
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${chainlink}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Chain link (<strong style={{color:"#ff2020"}}>couv+</strong>)</span>
                        {LINKModifCharge ? <span className='stat-see-card-detail-achat' onClick={validateChargeLINKHandler}>Valider</span> : null}
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                LINKModifCharge ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="link" label="XXXXX LINK" name="link" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                <div>
                                    <span className='stat-see-card-detail-achat' onClick={customChargeLINKHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>$ {NT_ChargeLINK}</span>
                                </div>
                            }
                        </div>
                    </div>
                </div> 
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${polkadot}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Polkadot (<strong style={{color:"#ff2020"}}>couv+</strong>)</span>
                        {DOTModifCharge ? <span className='stat-see-card-detail-achat' onClick={validateChargeDOTHandler}>Valider</span> : null}
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                DOTModifCharge ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="dot" label="XXXXX DOT" name="dot" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                <div>
                                    <span className='stat-see-card-detail-achat' onClick={customChargeDOTHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>$ {NT_ChargeDOTE}</span>
                                </div>
                            }
                        </div>
                    </div>
                </div> 
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${cardano}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Cardano (<strong style={{color:"#ff2020"}}>couv+</strong>)</span>
                        {ADAModifCharge ? <span className='stat-see-card-detail-achat' onClick={validateChargeADAHandler}>Valider</span> : null}
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'> 
                            {
                                ADAModifCharge ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="ada" label="XXXXX ADA" name="ada" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                <div>
                                    <span className='stat-see-card-detail-achat' onClick={customChargeADAHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>$ {NT_ChargeADA}</span>
                                </div>
                            }
                        </div>
                    </div>
                </div> 
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${solana}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Solana (<strong style={{color:"#ff2020"}}>couv+</strong>)</span>
                        {SOLModifCharge ? <span className='stat-see-card-detail-achat' onClick={validateChargeSOLHandler}>Valider</span> : null}
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                SOLModifCharge ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="sol" label="XXXXX SOL" name="sol" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                <div>
                                    <span className='stat-see-card-detail-achat' onClick={customChargeSOLHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>$ {NT_ChargeSOL}</span>
                                </div>
                            }
                        </div>
                    </div>
                </div> 
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${pm}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Perfect Money (<strong style={{color:"#ff2020"}}>couv+</strong>)</span>
                        {PMModifCharge ? <span className='stat-see-card-detail-achat' onClick={validateChargePMHandler}>Valider</span> : null}
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                PMModifCharge ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="pm" label="XXXXX PM" name="pm" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                <div>
                                    <span className='stat-see-card-detail-achat' onClick={customChargePMHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>$ {NT_ChargePM}</span>
                                </div>
                            }
                        </div>
                    </div>
                </div> 
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                        <img className='images-drapeau mr-2' src={`../${bnb}`} alt="" />
                        <span className='ml-2 stat-see-card-detail-bnt'>Binance Smart Chain (<strong style={{color:"#ff2020"}}>couv+</strong>)</span>
                        {BNBModifCharge ? <span className='stat-see-card-detail-achat' onClick={validateChargeBNBHandler}>Valider</span> : null}
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                            {
                                BNBModifCharge ? 
                                <div>
                                    <Box component="form" noValidate sx={{ mt: 1 }}>
                                        <TextField fullWidth id="bnb" label="XXXXX BNB" name="bnb" autoFocus onChange={currencyHandleChange}/>
                                    </Box>
                                </div> : 
                                <div>
                                    <span className='stat-see-card-detail-achat' onClick={customChargeBNBHandler}>Modifier</span>
                                    <span className='ml-2' style={{fontSize:"16px"}}>$ {NT_ChargeBNB}</span>
                                </div>
                            }
                        </div>
                    </div>
                </div> 
            </div>
            <div className='col-md-3'>
                <div className='stat-card'>
                    <div className='stat-card-title'>
                    </div>
                    <div className='d-flex justify-content-around'>
                        <div className='stat-card-content'>
                        </div>
                    </div>
                </div> 
            </div>
        </div>
    </div>
  )
}

export default Tarifications